import { ReactNode, forwardRef } from "react";
import { SubTrigger } from "@radix-ui/react-dropdown-menu";
const DropdownMenuSubTrigger = forwardRef<React.ElementRef<typeof SubTrigger>, React.ComponentPropsWithoutRef<typeof SubTrigger> & {
  inset?: boolean;
  Icon?: ReactNode;
}>(({
  className,
  Icon,
  inset,
  children,
  ...props
}, ref) => <SubTrigger ref={ref} className={`
      flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden focus:bg-muted dark:focus:bg-muted/10 data-[state=open]:bg-muted dark:bg-muted/10
      ${inset && "pl-8"}
      ${className}`} {...props}>
    {children}
    {Icon ?? ""}
  </SubTrigger>);
DropdownMenuSubTrigger.displayName = SubTrigger.displayName;
export { DropdownMenuSubTrigger };